import './App.css';
import './components/Report.css';
import './components/ModernReport.css';
import {BrowserRouter as Router, Routes, Route, useLocation} from 'react-router-dom';
import { useEffect } from 'react';

import { getAuth } from 'firebase/auth';
import { ref, onValue } from 'firebase/database';
import { database } from './utils/firebase';


import Home from './components/public/Home/Home'
import Pricing from './components/public/Pricing/Pricing'
import About from "./components/public/About/About";
import NotFound from './components/public/NotFound/NotFound'

import Debug from "./utils/Debug";
import BugReport from "./components/public/BugReport/BugReport";

import Footer from "./components/reusable_elements/Footer/Footer";
import Header from "./components/reusable_elements/Header/Header";

import Dashboard from "./components/Dashboard/Dashboard";
import LeagueDashboard from "./components/league_admin/League_Dashboard/League_Dashboard";
import Match from "./components/league_admin/Match/Match";
import Players from "./components/league_admin/Players/Players";
import HandicapsAndFlights from "./components/league_admin/HandicapsAndFlights/HandicapsAndFlights";
import EditHandicaps from "./components/league_admin/HandicapsAndFlights/EditHandicaps";
import LeagueSettings from "./components/league_admin/Settings/LeagueSettings";
import PayoutSettings from "./components/league_admin/PayoutSettings/PayoutSettings/PayoutSettings";
import Payout from "./components/league_admin/PayoutSettings/Payout/Payout";
import ReportGenerator from "./components/league_admin/ReportGenerator/ReportGenerator";

import Login from "./components/Authentication/Login/Login.jsx";
import CreateAccount from "./components/Authentication/CreateAccount/CreateAccount";
import AccountSettings from "./components/Authentication/AccountSettings/AccountSettings";
import PasswordReset from "./components/Authentication/PasswordReset/PasswordReset";

import PR from "./components/utils/ProtectedRoute";

import LeagueAccessApproval from "./components/league_admin/LeagueAccessApproval/LeagueAccessApproval";

import MatchReport from "./components/leagueUtils/MatchReport";
import PayoutsReport from "./components/leagueUtils/PayoutsReport";
import WinnersReport from "./components/leagueUtils/WinnersReport";
import MatchSchedule from "./components/leagueUtils/MatchSchedule";
import RosterReport from "./components/leagueUtils/RosterReport";
import HandicapReport from "./components/leagueUtils/HandicapReport";
import BlankScoreSheet from "./components/leagueUtils/BlankScoreSheet";
import LeagueCreationWizard from "./components/LeagueCreationWizard/LeagueCreationWizard";

import ReactGA from 'react-ga4';
import LeagueAccessPost from "./components/league_admin/LeagueAccessApproval/LeagueAccessPost";
import LeagueAppAccessTool from "./components/utils/LeagueAppAccessTool";

const AppContent = () => {
    const location = useLocation();
    const auth = getAuth();
    const user = auth.currentUser;

    const excludeHeaderFooter = location.pathname.startsWith('/utils') || location.pathname.startsWith('/auth');
    ReactGA.initialize("G-NNLRWM8VSC")

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    }, []);

    useEffect(() => {
        if (user) {
            const userRef = ref(database, `people/${user.uid}`);
            onValue(userRef, (snapshot) => {
                const data = snapshot.val();
                if (data?.preview) {
                    const newBaseUrl = `https://golf-league-tools-preview.vercel.app${location.pathname}`;
                    if (window.location.hostname !== 'golf-league-tools-preview.vercel.app') {
                        window.location.replace(newBaseUrl);
                    }
                }
            });
        }
    }, [user, location]);



    return (
        <div className="app-container">
            {!excludeHeaderFooter && <Header />}
            <main className="content">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/about" element={<About />} />
                    <Route path='/utils/debug' element={<Debug />} />
                    <Route path='/utils/bug-report' element={<BugReport />} />
                    <Route path="/app" element={<PR><Dashboard /></PR>} />
                    <Route path="/auth/login" element={<Login />} />
                    <Route path="/auth/signup" element={<CreateAccount />} />
                    <Route path="/auth/account/utils/password/reset" element={<PasswordReset />} />
                    <Route path="/auth/account/utils/preferences/update" element={<PR><AccountSettings /></PR>} />
                    <Route path="/app/leagueWizard" element={<PR><LeagueCreationWizard /></PR>} />
                    <Route path="/app/league/:leagueId/dashboard" element={<PR><LeagueDashboard /></PR>} />
                    <Route path="/app/league/:leagueId/match/:matchId" element={<PR><Match /></PR>} />
                    <Route path='/app/league/:leagueId/players' element={<PR><Players /></PR>} />
                    <Route path='/app/league/:leagueId/handicaps' element={<PR><HandicapsAndFlights /></PR>} />
                    <Route path='/app/league/:leagueId/handicap/:handicapId' element={<PR><EditHandicaps /></PR>} />
                    <Route path='/app/league/:leagueId/settings' element={<PR><LeagueSettings /></PR>} />
                    <Route path='/app/league/:leagueId/reports' element={<PR><ReportGenerator /></PR>} />
                    <Route path='/app/league/:leagueId/payouts' element={<PR><PayoutSettings /></PR>} />
                    <Route path='/app/league/:leagueId/payout/:payoutId' element={<PR><Payout /></PR>} />
                    <Route path='/utils/auth/LIDAccess/:appId' element={<PR><LeagueAccessApproval /></PR>} />
                    <Route path='/utils/auth/LIDPost/:appId/:leagueId' element={<PR><LeagueAccessPost /></PR>} />

                    <Route path='/utils/league/reports/matchReport/:leagueId/:matchId/:print/:header' element={<PR><MatchReport /></PR>} />
                    <Route path='/utils/league/reports/payoutsReport/:leagueId/:matchId/:startDate/:endDate/:print/:header' element={<PR><PayoutsReport /></PR>} />
                    <Route path='/utils/league/reports/winnersReport/:leagueId/:matchId/:print/:header' element={<PR><WinnersReport /></PR>} />
                    <Route path='/utils/league/reports/matchSchedule/:leagueId/:startDate/:endDate/:print/:header' element={<PR><MatchSchedule /></PR>} />
                    <Route path='/utils/league/reports/payoutsReport/:leagueId/:startDate/:endDate/:print/:header' element={<PR><PayoutsReport /></PR>} />
                    <Route path='/utils/league/reports/rosterReport/:leagueId/:activeDate/:print/:header' element={<PR><RosterReport /></PR>} />
                    <Route path='/utils/league/reports/handicapReport/:leagueId/:handicapId/:print/:header' element={<PR><HandicapReport /></PR>} />
                    <Route path='/utils/league/reports/blankScoreSheet/:leagueId/:matchId/:print/:header' element={<PR><BlankScoreSheet /></PR>} />

                    <Route path='/app/apps/leagueUrlTool' element={<PR><LeagueAppAccessTool /></PR>} />

                    <Route path="*" element={<NotFound />} />
                </Routes>
            </main>
            {!excludeHeaderFooter && <Footer />}
        </div>
    );
};

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;